import React from "react"
import PropTypes from "prop-types"
import { graphql } from "gatsby"
import RichText from "../atoms/RichText"

const Faq = ({ title, richText, textAlign = "left", rest }) => {
  if (!richText?.content) return null

  const rightMargin = textAlign === "left" ? { _: 0, md: 9, lg: 13 } : 0

  return (
    <RichText
      shadow="none"
      textAlign={textAlign}
      mt={0}
      mr={rightMargin}
      mb={4}
      // ml={{ _: 0, md: 6 }}
      {...richText}
      {...rest}
    />
  )
}

export default Faq

Faq.strapiProps = {
  title: PropTypes.string,
  paragraph: PropTypes.object,
}

Faq.propTypes = {
  ...Faq.strapiProps,
  textAlign: PropTypes.oneOf(["left", "center", "right"]),
}

export const query = graphql`
  fragment Faq on STRAPI__COMPONENT_MOLECULES_FAQ {
    title
    richText {
      ...RichText
    }
  }
`
